import { render } from "./QuestionModal.vue?vue&type=template&id=f0cd8e64&scoped=true"
import script from "./QuestionModal.vue?vue&type=script&lang=js"
export * from "./QuestionModal.vue?vue&type=script&lang=js"

import "./QuestionModal.vue?vue&type=style&index=0&id=f0cd8e64&lang=scss&scoped=true"
import "./QuestionModal.vue?vue&type=style&index=1&id=f0cd8e64&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0cd8e64"]])

export default __exports__